export const shortTeamName = (teamName) => {
    return teamName.replaceAll(" ", "").substring(0, 3);
}